<template>
    <div :id="containerId" class="nrp-dot-tag">
        <span :id="tooltipId" class="isNrp">
            <img class="det_icon" src="https://resource.rcclchina.com.cn/tui2/info/tips.png">
        </span>
        <b-tooltip :target="tooltipId" :container="containerId" triggers="hover" :placement="direction">
            <div v-html="description"></div>
        </b-tooltip>
    </div>
    
</template>

<script>
import nrpConfig from '@/utilities/nrpConfig'
export default {
    name: "NrpTag",
    props: {
        isNrp: {
            type: Boolean
        },
        isFortyEightHoursNrpCruise: {
            type: Boolean
        },
        index: {
            type: String
        },
        direction: {
            type: String,
            default() {
                return 'right'
            }
        },
        showRow: {
            type: Boolean,
            default: false,
        },
    },
    
    computed: {
        title () {
            
            if (this.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.title
            } else if (this.isNrp) {
                return nrpConfig.nrp.title
            }
            return nrpConfig.rp.title
        },
        description () {
            // console.log(this.showRow,'NrpDotTagNrpDotTag')
            // console.log(this.isNrp,'isNrpisNrpisNrp')
            // console.log(this.$store.state.cruiseRow.nrpData,'nrpDatanrpData')

            if (this.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.description
            } else if (this.isNrp) {
                // 收费退订
                if(this.showRow){
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyNrpRow
                }else{
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyNrp
                }
            }
            // 常规退订

            if(this.showRow){
                return this.$store.state.cruiseRow.nrpData.cancelPolicyRow
            }else{
                return this.$store.state.cruiseRow.nrpData.cancelPolicy
            }
        },
        tooltipId () {
            if (!this.index || this.index == '') {
                return 'nrpTag_tooltip_' + (new Date()).getTime() + Math.round(Math.random()*100000);
            }
            return 'nrpDotTag_tooltip_' +this.index
        },
        containerId () {
            if (!this.index || this.index == '') {
                return 'nrpTag_container_' + (new Date()).getTime() + Math.round(Math.random()*100000)
            }
            return 'nrpDotTag_container_' +this.index
        }
    }
}
</script>

<style lang="less" scoped>
.nrp-dot-tag {
    display: inline-block;
    height: 16px;
    span.nrpTooltip {
        display: inline-block;
        height: 16px;
        color: #337ab7;
        cursor: pointer;
    }
}
</style>

<style lang="less">
.nrp-dot-tag {
    .arrow {
        position: absolute;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
    }
    .tooltip.bs-tooltip-right {
        padding: 0 5px;
        margin-left: 3px;
        .arrow {
            top: 50%;
            left: 0;
            margin-top: -5px;
            border-width: 5px 5px 5px 0;
            border-right-color: #fff;
        }
    }
    
}
/*收费常规*/
.cabinDetail-box + .cabinDetail-box {
    margin-top: 10px;
}

.cabinDetail-box {
    padding: 0 10px;
    background-color: #fff;
}

.cabinDetail-txt-bold {
    color: #333;
    font-weight: bold;
}

.cabinDetail-txt {
    padding-bottom: 13px;
    font-size: 12px;
    line-height: 20px;
    color: #666;
}

.blue {
    color: #4A90E2;
}

.cabinDetail-txt .cabinDetail-txt-bold {
    margin: 10px 0 0;
}

</style>